<template>
  <div class="container">
    <div class="containerWrap">
      <div class="topLogo">
        <div class="topLogoMain">
          <div class="topLogoMainLeft">
            <router-link to="/">
              <img src="../assets/img/Logo1j.png" class="Nlogo" />
            </router-link>
          </div>
          <div class="topLogoMainRight">
            <div class="addsc" style="float: right">
              <a href="" class="a1">设为首页</a>
              <a href="" class="a2">添加收藏</a>
            </div>
            <div class="header_search">
              <div>
                <input
                  type="text"
                  v-model="searchValue"
                  name="KeyWord"
                  required="required"
                  placeholder="请输入标题"
                  class="form-control"
                  style="float:left;"
                />
                <el-button
                  type="submit"
                  class="btn "
                  @click="handleSearch"
                  style="float:left; background-color:#FFFFFF; 
                  border-radius:0px;"
                  ><i class="iconfont">&#xe782; </i>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="topMenu">
        <div class="topMenuMain">
          <div class="nav_box">
            <ul class="menuUL">
              <li class="menuLi">
                <div class="nav_grop">
                  <h2><router-link to="/">网站首页</router-link></h2>
                  <span class="span1"></span>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" class="menuLi">
                <div class="nav_grop" @mouseenter="navShow(item.channelId)" @mouseleave="navClose()">
                  <h2>
                    <a
                      v-if="item.child.length && item.child[0].url && item.child[0].url !== ''"
                      target="_blank"
                      :href="item.url"
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="item.child.length && (!item.child[0].url || item.child[0].url == '')"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.child[0].entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.child[0].entTChannelUuid}`
                          : `/listPic/${item.child[0].entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="!item.child.length"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.entTChannelUuid}`
                          : `/listPic/${item.entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                  </h2>

                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="transition-box" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1" class="transitLI">
                          <a
                            v-if="item1.child.length && item1.child[0].url && item1.child[0].url !== ''"
                            target="_blank"
                            :href="item1.url"
                          >
                            {{ item1.name }}
                          </a>
                          <a
                            v-if="item1.child.length && (!item1.child[0].url || item1.child[0].url == '')"
                            :href="
                              item1.catalog === 1
                                ? `/listPage/${item1.child[0].entTChannelUuid}`
                                : item1.catalog === 2
                                ? `/list/${item1.child[0].entTChannelUuid}`
                                : `/listPic/${item1.child[0].entTChannelUuid}`
                            "
                          >
                            {{ item1.name }}
                          </a>
                          <a
                            v-if="!item1.child.length"
                            :href="
                              item1.catalog == 1
                                ? `/listPage/${item1.entTChannelUuid}`
                                : item1.catalog == 2
                                ? `/list/${item1.entTChannelUuid}`
                                : `/listPic/${item1.entTChannelUuid}`
                            "
                          >
                            {{ item1.name }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                  <span class="span1" v-if="index < navList.length - 1"></span>
                  <span class="span2"></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main" style="background-color: #fff">
        <router-view></router-view>
      </div>
      <div class="footer">
        <div class="footMain" style="width: 100% !important;">
          <!-- <div class="linkBg">
            <div class="Twpage FriendLink">
              <div class="Tpage">
                <div class="link">
                  
                  <select style="width: 238px; margin-right: 70px;"  onchange="javascript:window.open(this.options[this.selectedIndex].value);">
                    <option selected=""> ----内部链接---- </option>
                    <option value="http://www.gsjtw.cc/">甘肃建投</option>
                    <option value="http://www.gsejjt.cn/">甘肃第二建设集团有限责任公司</option>
                    <option value="http://www.gssanjian.com/">甘肃第三建设集团公司</option>
                    <option value="http://www.gssjjt.com/">甘肃第四建设集团有限责任公司</option>
                    <option value="http://www.gs5j.com/">甘肃第五建设集团公司</option>
                    <option value="http://www.gsljw.com/">甘肃第六建设集团股份有限公司</option>
                    <option value="http://www.gs7j.com.cn/">甘肃第七建设集团股份有限公司</option>
                    <option value="http://www.gs8j.com/">甘肃省第八建设集团有限责任公司</option>
                    <option value="http://gnjj.jidian888.cn/">甘肃第九建设集团公司</option>
                    <option value="http://www.gsya.com.cn/">甘肃第一安装工程有限公司</option>
                    <option value="http://www.gsazjsjt.com/">甘肃省安装建设集团公司</option>
                    <option value="http://www.gjtsst.com/">甘肃建投天水混凝土有限公司</option>
                    <option value="http://www.gsjtsd.com/">甘肃建投隧道工程有限公司</option>
                    <option value="http://www.gjkygs.com/">甘肃省建筑科学研究院</option>
                    <option value="http://www.gcigcem.com.cn/">甘肃建投装备制造有限公司</option>
                    <option value="http://www.gsjtjs.com/">甘肃建投建设有限公司</option>
                    <option value="http://www.cgicop.com/">中国甘肃国际经济技术合作总公司</option>
                    <option value="http://www.gsjtst.com/">甘肃建投商品混凝土有限公司</option>
                    <option value="http://www.gsjtpxzx.com/">甘肃建投培训中心</option>
                    <option value="http://www.gsjtzcjygs.com/">甘肃建投资产经营有限公司</option>
                    <option value="http://gsjtky.com/">甘肃建投矿业有限公司</option>
                    <option value="http://gsjttm.com/">甘肃建投土木工程建设有限公司</option>
                    <option value="http://www.gsjtts.com/">甘肃建投天水建设管理有限公司</option>
                    <option value="http://gsjiantouzhiye.com/">甘肃建总置业发展有限公司</option>
                    <option value="http://www.gsjt56.com/">甘肃建投物流集团公司</option>
                  </select>

                  <select style="width:238px; margin-right: 70px;" onchange="javascript:window.open(this.options[this.selectedIndex].value);">
                    <option selected=""> ----友情链接---- </option>
                    <option value="http://gzw.gansu.gov.cn/">甘肃省国有资产监督管理委员会</option>
                    <option value="http://zjt.gansu.gov.cn/">甘肃省住房和城乡建设厅</option>
                    <option value="http://www.scg.com.cn/">上海建工集团有限公司</option>
                    <option value="http://www.sxjgjt.com.cn/">山西建设投资集团有限公司</option>
                    <option value="http://www.hljhcgc.com/">黑龙江省建工集团有限责任公司</option>
                    <option value="http://www.shxi-jz.com/">陕西建工集团有限公司</option>
                    <option value="http://www.jsce.com.cn/">江苏省建工集团有限公司</option>
                    <option value="http://www.aceg.com.cn/">安徽建工集团有限公司</option>
                    <option value="http://www.jxsjgjt.com/">江西省建工集团有限责任公司</option>
                    <option value="http://www.zjsjg.com/index.aspx">浙江省建工集团有限责任公司</option>
                    <option value="http://www.fjjg.com.cn/">福建建工集团有限责任公司</option>
                    <option value="http://www.ynjstzkg.com/">云南省建工投资控股集团有限公司</option>
                    <option value="http://www.gdceg.com/">广东省建筑工程集团有限公司</option>
                    <option value="http://www.sdjiangong.com.cn/">山东省建设建工（集团）有限责任公司</option>
                  </select>

                  <select  style="width:238px; margin-right: 70px;" onchange="javascript:window.open(this.options[this.selectedIndex].value);">
                    <option selected=""> ----行业链接---- </option>
                    <option value="http://www.chinajsb.cn/">中国建设报</option>
                    <option value="http://www.zgjzy.org.cn/">中国建筑业协会</option>
                    <option value="http://www.gssjzylhh.com/">甘肃省建筑业联合会</option>
                    <option value="http://dzb.jzsbs.com/epaper/jzsb/pc/content/202011/26/content_10734.html">建筑时报</option>
                  </select>

                  <select  style="width:238px;" onchange="javascript:window.open(this.options[this.selectedIndex].value);">
                    <option selected=""> ----推荐链接---- </option>
                    <option value="http://www.gov.cn/">中国政府网</option>
                    <option value="http://cpc.people.com.cn/">中国共产党新闻网</option>
                    <option value="http://www.sasac.gov.cn/">国务院国资委</option>
                    <option value="http://www.gscn.com.cn/">中国甘肃网</option>
                    <option value="http://www.mohurd.gov.cn/">住建部</option>
                  </select>
                  
                </div> 
              </div>
            </div>
          </div> -->

          <div class="EndLink">
            <div class="Tpage">
              <div class="Left">
                <div class="tit">便捷导航</div>
                <ul>
                  <li>
                    <a href="/listPage/yiji00010003" target="_blank" class="big">公司概况</a>
                    <a href="/listPage/yiji00010001" target="_blank" class="small">董事长致辞</a>
                    <a href="/listPage/yiji00010003" target="_blank" class="small">企业简介</a>
                    <a href="/listPage/yiji00010004" target="_blank" class="small">企业荣誉</a>
                  </li>
                  <li>
                    <a href="/list/yiji00020001" target="_blank" class="big">新闻动态</a>
                    <a href="/list/yiji00020001" target="_blank" class="small">公司要闻</a>
                    <a href="/list/yiji00020002" target="_blank" class="small">建投要闻</a>
                    <a href="/list/yiji00020003" target="_blank" class="small">基层动态</a>
                    <a href="/list/yiji00020004" target="_blank" class="small">行业动态</a>
                    <a href="/list/yiji00020005" target="_blank" class="small">媒体聚焦</a>
                  </li>
                  <li>
                    <a href="/list/yiji0003" target="_blank" class="big">党群工作</a>
                    <!-- <a href="/list/yiji0011" target="_blank" class="big">聚焦党的十九届六中全会</a>   -->
                  </li>
                  <li>
                    <a href="/list/yiji00040001" target="_blank" class="big">企业文化</a>
                    <a href="/list/yiji00040001" target="_blank" class="small">一建之声</a>
                    <a href="/list/yiji00040002" target="_blank" class="small">文化活动</a>
                    <a href="/list/yiji00040003" target="_blank" class="small">职工文苑</a>
                    <a href="/list/yiji00040004" target="_blank" class="small">品牌建设</a>
                  </li>
                  <li>
                    <a href="/list/yiji0005" target="_blank" class="big">学习园地</a>
                    <!-- <a href="/list/yiji0012" target="_blank" class="big">学党史 悟思想 办实事 开新局</a> -->
                  </li>
                  <li>
                    <a href="/list/yiji00060001" target="_blank" class="big">通知公告</a>
                    <a href="/list/yiji00060001" target="_blank" class="small">通知文件</a>
                    <a href="/list/yiji000600020001" target="_blank" class="small">招标公告</a>
                    <!-- <a href="/list/yiji0010" target="_blank" class="big">《保障农民工工资支付条例》宣传专栏</a> -->
                  </li>
                  <li>
                    <a href="/listPic/yiji0007" target="_blank" class="big">精品展示</a>
                    <a href="" class="big">联系我们</a>
                    <!-- <a href="/list/yiji0009" target="_blank" class="big">不忘初心 牢记使命</a>                 -->
                  </li>
                  <!-- <li>
                      <a href="/list/yiji0011" target="_blank" class="big_li2" >聚焦党的十九届六中全会</a>
                      <a href="/list/yiji0012" target="_blank" class="big_li2">学党史 悟思想 办实事 开新局</a>  
                      <a href="/list/yiji0010" target="_blank" class="big_li2">《保障农民工工资支付条例》宣传专栏</a>
                      <a href="/list/yiji0009" target="_blank" class="big_li2">不忘初心 牢记使命</a>   
                    </li> -->
                </ul>
              </div>
              <div class="Center">
                <div class="tit">联系我们</div>
                <b>热线电话：</b><br />
                <span style="margin-top: 14px;">0931-8328726</span>
                <span>0931-8328651</span>
                <p>周一至周五 早8:30—晚5:30<br />兰州市安宁区北滨河中路1272号</p>
              </div>
              <div class="Right">
                <img src="../assets/img/ewm.png" />
                <br />
                甘肃一建微信公众号
              </div>
            </div>
          </div>
          <div class="Foot">
            甘肃第一建设集团有限责任公司 版权所有&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="http://beian.miit.gov.cn/" target="_blank">陇ICP备18003646号-2</a> &nbsp;&nbsp;&nbsp;&nbsp;
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010502000237">
              <img src="../assets/img/beian.png" />甘公网安备 62010502000237号
            </a>
            <br />
            地址：兰州市安宁区北滨河中路1272号&nbsp;&nbsp;&nbsp;&nbsp; 邮箱：gsyijian@126.com&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNavChannel } from '@/api/common'

export default {
  name: '',
  data() {
    return {
      searchValue: '',
      active: 0,
      navList: [],
      navDown: 0
    }
  },
  mounted() {
    this.getPath()
    this.getNavChannel()
  },
  created() {},
  watch: {
    $route: 'getPath'
  },
  methods: {
    // 获取导航
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 7)
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
      }
    },
    // 二级导航展开
    navShow(d) {
      let _this = this
      // _this[d] = true
      _this.navDown = d
    },
    // 二级导航收起
    navClose() {
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params) {
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath() {
      var _this = this
      _this.active = _this.$route.meta.index
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'iconfont'; /* Project id 3165120 */
  src: url('//at.alicdn.com/t/font_3165120_76d7pwtenjr.woff2?t=1645689140903') format('woff2'),
    url('//at.alicdn.com/t/font_3165120_76d7pwtenjr.woff?t=1645689140903') format('woff'),
    url('//at.alicdn.com/t/font_3165120_76d7pwtenjr.ttf?t=1645689140903') format('truetype');
}

@font-face {
  font-family: 'iconfont'; /* project id 3165259 */
  src: url('');
  src: url('?#iefix') format('embedded-opentype'),
    url('//at.alicdn.com/t/font_3165259_4zwhtyd54xp.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_3165259_4zwhtyd54xp.woff') format('woff'),
    url('//at.alicdn.com/t/font_3165259_4zwhtyd54xp.ttf') format('truetype'), url('#iconfont') format('svg');
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.topLogo {
  overflow: hidden;
  padding: 0px 0px;
  background: url(../assets/img/TopLine.jpg);
}
.topLogoMain {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.topLogoMainLeft {
  width: 710px;
  overflow: hidden;
  margin-top: 11px;
  margin-bottom: 12px;
}
.topLogoMainLeft {
  float: left !important;
}
.topLogoMainRight {
  width: 380px;
  height: 110px;
  margin-top: 30px;
  overflow: hidden;
}
.topLogoMainRight {
  float: right !important;
}
.header_search {
  width: 380px;
  height: 51px;
  overflow: hidden;
  float: right;
  position: relative;
  margin-top: 10px;
}
.header_search input {
  width: 300px;
  height: 24px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 352px;
  font-size: 14px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #e6e6e6;
  background-color: #fff;
}

.addsc .a1 {
  background: url(../assets/img/sc2.png) left center no-repeat;
}
.addsc .a2 {
  background: url(../assets/img/sc1.png) left center no-repeat;
}
.addsc a {
  color: #a6a6a6;
  width: 70px;
  float: left;
  margin-right: 15px;
  text-align: right;
  font-size: 12px;
  height: 30px;
  line-height: 33px;
  display: block;
}

.form-control {
  display: block;
  padding: 6px 12px;
}
.btn {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  padding: 0px 12px;
  color: #1c1c1c;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  border: solid 1px #e6e6e6;
  cursor: pointer;
}
.topMenu {
  height: 50px;
  background-color: #0062b3;
  // overflow: hidden;
  border-bottom: 1px #ffffff solid;
}
.topMenuMain {
  width: 100%;
  height: auto;
  // overflow: hidden;
  margin: 0 auto;
  text-align: center;
}
.topMenuMain .menuUL {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
}
.topMenuMain .menuUL .menuLi {
  position: relative;
  width: 148px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
  z-index: 22;
  margin-left: 2px;
}
.topMenuMain .menuUL li:hover {
  background-color: rgba(7, 6, 63, 0.425) !important;
}
.topMenuMain .menuLi a {
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  color: #ffffff;
}
.span1 {
  width: 2px;
  height: 50px;
  border-left: 1px #a4bacf solid;
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  margin-right: -4px;
}
.span2 {
  width: 2px;
  height: 50px;
  display: inline-block;
}
.topMenuMain .menuLi a {
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  color: #ffffff;
  display: block;
  height: 50px;
  line-height: 50px;
}
.transition-box .transitLI {
  background-color: #0062b3;
  border-top: 1px solid #99a5b1;
}
.transition-box .transitLI a {
  width: 148px;
  height: 35px;
  line-height: 35px;
  display: block;
  color: #ffffff;
  font-weight: normal;
  font-size: 13px;
}
.transition-box .transitLI a:hover {
  background-color: rgba(7, 6, 63, 0.425) !important;
}

.footMain {
  height: auto;
  margin: 0px auto;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1, Tahoma, Arial, sans-serif;
}
.linkBg {
  width: 100%;
  background-color: #e7e7e7;
  height: auto;
}
.Tpage {
  width: 1200px;
  overflow: hidden;
  margin: 0px auto;
}
.FriendLink {
  height: 32px;
  padding: 22px 0px;
}
.Twpage {
  width: 100%;
  overflow: hidden;
}
.FriendLink select {
  height: 32px;
  width: 238px;
}

a,
a:focus,
a:hover {
  text-decoration: none;
}
a {
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  color: #000000;
}
.EndLink {
  width: 100%;
  background-color: #004a87;
  padding: 30px 0px;
  color: #ffffff;
}
.EndLink .Left {
  width: 820px;
  float: left;
  overflow: hidden;
}
.EndLink .Left .tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}
.EndLink .Left li {
  width: 116px;
  float: left;
  // overflow: hidden;
  line-height: 30px;
  font-size: 12px;
  text-align: center;
}

.EndLink .Left .big_li2 {
  width: 168px;
  font-size: 13px;
  text-align: left;
  font-size: 13px;
  font-weight: bolder;
}

li {
  list-style: none;
}
.EndLink .Left li .big {
  height: 35px;
  line-height: 35px;
  font-size: 13px;
  font-weight: bolder;
}
.EndLink .Left li a {
  width: 100%;
  display: block;
  text-align: center;
  color: #ffffff;
}
.EndLink .Left li .small {
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  color: #a5c1d7;
}

.EndLink .Center {
  width: 172px;
  float: left;
  margin-left: 20px;
  overflow: hidden;
}
.EndLink .Center .tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-bottom: 8px;
}
.EndLink .Center b {
  font-size: 13px;
}
.EndLink .Center span {
  color: #fff004;
  font-size: 26px;
  padding: 0px 0px 10px 0px;
  display: block;
  width: 100%;
}

.EndLink .Center p {
  color: #ffffff;
  line-height: 22px;
  font-size: 12px;
}
.EndLink .Right {
  width: 150px;
  float: right;
  text-align: center;
  line-height: 40px;
}
.EndLink .Right img {
  width: 105px;
  height: 105px;
  margin-top: 5px;
}
img {
  display: inline-block;
  border: none;
}
.footer {
  height: 76px;
}
.main {
  height: auto;
}
.Foot {
  width: 100%;
  overflow: hidden;
  line-height: 25px;
  padding: 20px 0px;
  background-color: #004a87;
  text-align: center;
  color: #a4c0d5;
  border-top: 1px #6284a0 solid;
}
.Foot a {
  color: #a4c0d5;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1, Tahoma, Arial, sans-serif;
}
</style>
